import { Features } from "../../enums/features";
import { BusinessFunctionFeatureDto } from "./businessfunctionfeaturedto";

export class EmailDigestFeatureDto extends BusinessFunctionFeatureDto{
override $type: string;

constructor(enabled: boolean) {
    super(Features.EmailDigest, "MultiJurisdictionCms.Dto.Features.EmailDigestFeatureDto, MultiJurisdictionCms.Dto");
        this.$type = "MultiJurisdictionCms.Dto.Features.EmailDigestFeatureDto, MultiJurisdictionCms.Dto";
        this.enabled = enabled;
    
}
}